"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import PageSection from "@/components/shared/page-section";

type ReservedEmptyStateProps = {
	title?: string;
	description?: string;
	buttonLabel?: string;
	href?: string;
	className?: string;
};

export default function ReservedEmptyState({
	title = "Area riservata",
	description = "Nessun contenuto disponibile.",
	buttonLabel = "Torna alla home",
	href = "/",
	className = "",
}: ReservedEmptyStateProps) {
	return (
		<PageSection className={className}>
			<div className="max-w-xl mx-auto bg-(--card) text-(--card-foreground) border border-black/5 rounded-xl p-6 text-center shadow-sm">
				<h2 className="text-2xl font-semibold mb-2">{title}</h2>
				<p className="text-(--muted-foreground) mb-4">{description}</p>
				<Button
					asChild
					className="cursor-pointer bg-(--btn-bg) text-(--btn-foreground) hover:bg-(--btn-hover)"
				>
					<Link href={href}>{buttonLabel}</Link>
				</Button>
			</div>
		</PageSection>
	);
}